import React, { useEffect, useRef, useState } from "react";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf.js";
import "pdfjs-dist/legacy/build/pdf.worker.entry.js";
import { getBlob, ref } from "firebase/storage";
import { storage } from "../Config/firebase";
import "./RelatorioModuloElasticidadePrint.css";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";

function formatarDataBR(dataISO) {
  if (!dataISO) return "";
  const [ano, mes, dia] = String(dataISO).split("-");
  if (!ano || !mes || !dia) return dataISO;
  return `${dia}/${mes}/${ano}`;
}

function formatarDataExtenso(dataISO) {
  if (!dataISO) return "";

  const meses = [
    "janeiro",
    "fevereiro",
    "marco",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro",
  ];

  const [ano, mes, dia] = String(dataISO).split("-");
  if (!ano || !mes || !dia) return dataISO;
  const data = new Date(`${dataISO}T00:00:00`);
  const diaSemana = data.toLocaleDateString("pt-BR", { weekday: "long" });
  return `${diaSemana}, ${Number(dia)} de ${meses[Number(mes) - 1]} de ${ano}`;
}

function numero(valor) {
  if (valor === "" || valor === null || valor === undefined) return null;
  const n = Number(String(valor).replace(",", "."));
  return Number.isFinite(n) ? n : null;
}

function numeroBR(valor, casas = 2) {
  const n = numero(valor);
  if (n === null) return "";
  return n.toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}

function media(valores, casas = 1) {
  const nums = valores.map(numero).filter((v) => v !== null);
  if (!nums.length) return "";
  return numeroBR(nums.reduce((soma, item) => soma + item, 0) / nums.length, casas);
}

function valor(valorCampo, fallback = "-") {
  return valorCampo === "" || valorCampo === null || valorCampo === undefined ? fallback : valorCampo;
}

function fckComUnidade(valorCampo) {
  const texto = String(valorCampo || "").trim();
  if (!texto) return "-";
  return /mpa$/i.test(texto) ? texto : `${texto} MPa`;
}

function diferencaDias(dataInicial, dataFinal) {
  if (!dataInicial || !dataFinal) return "";

  const inicio = new Date(`${dataInicial}T00:00:00`);
  const fim = new Date(`${dataFinal}T00:00:00`);
  if (Number.isNaN(inicio.getTime()) || Number.isNaN(fim.getTime())) return "";

  const dias = Math.round((fim.getTime() - inicio.getTime()) / 86400000);
  if (!Number.isFinite(dias) || dias < 0) return "";
  return `${dias} dias`;
}

function numeroIdade(idade) {
  const match = String(idade || "").match(/\d+/);
  return match ? match[0] : "";
}

function imprimirEmRetrato() {
  window.print();
}

function Cabecalho({ modulo, dataRelatorio, codigoCompacto = false }) {
  return (
    <>
      <table className="cabecalho">
        <tbody>
          <tr>
            <td rowSpan="3" className="logo-cell">
              <LogoRelatorio alt="Logo" className="logo"  />
            </td>
            <td rowSpan="3" className="titulo-principal">
              SISTEMA DE GESTÃO DA QUALIDADE
              <br />
              Relatório - Módulos de elasticidade e de deformação NBR8522-2
            </td>
            <td className="rq-cell">RQ 2.2.13</td>
          </tr>
          <tr>
            <td>REVISÃO 00</td>
          </tr>
          <tr>
            <td>20/08/2025</td>
          </tr>
        </tbody>
      </table>

      <div className="linha-info">
        <span>
          <strong>Data:</strong> {formatarDataBR(dataRelatorio)}
        </span>
        {!codigoCompacto && (
          <span>
          <strong>CÓDIGO:</strong> {modulo.codigo || "-"}
          </span>
        )}
      </div>
    </>
  );
}

function BlocoEmpresa({ modulo, ensaio = true }) {
  return (
    <div className="bloco-empresa">
      <div>
        <strong>EMPRESA:</strong>
        <span>{valor(modulo.cliente)}</span>
      </div>
      <div>
          <strong>LOCAL/OBRA:</strong>
        <span>{valor(modulo.obra)}</span>
      </div>
      {ensaio && (
        <div>
          <strong>ENSAIO:</strong>
          <span>Determinação dos módulos de elasticidade e de deformação NBR-8522-2</span>
        </div>
      )}
    </div>
  );
}

function Secao({ numero: n, titulo, children }) {
  return (
    <>
      <div className="secao">{n}. {titulo}</div>
      {children && <div className="texto">{children}</div>}
    </>
  );
}

function Assinatura({ modulo }) {
  return (
    <div className="assinatura-area">
      <div>{formatarDataExtenso(modulo.dataEnsaio || modulo.dataRelatorio)}</div>
      <div className="assinatura">
        <img src="/Images/assinaturaLeal.png" alt="Assinatura" />
        <div className="linha-assinatura" />
        <strong>José Carlos Lemes Leal</strong>
        <span>Eng. Civil CREA 203379/D - TO</span>
      </div>
    </div>
  );
}

function RodapeRestrito() {
  return (
    <div className="rodape-restrito">
      <div className="linha-rodape" />
      <div>DOCUMENTO PARA USO RESTRITO. REPRODUÇÃO/CÓPIA PROIBIDA SEM AUTORIZAÇÃO DA EMPRESA</div>
    </div>
  );
}

function PaginaAnexoCapa({ modulo, dataRelatorio }) {
  return (
    <div className="pagina anexo-capa">
      <Cabecalho modulo={modulo} dataRelatorio={dataRelatorio} codigoCompacto />
      <BlocoEmpresa modulo={modulo} ensaio={false} />
      <RodapeRestrito />
      <div className="titulo-anexo">ANEXO 1 - MÓDULO DE ELASTICIDADE DO CONCRETO ENDURECIDO</div>
    </div>
  );
}

function PdfDocumentoImagem({ documento, alt }) {
  const [imagemPdf, setImagemPdf] = useState(null);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    let ativo = true;

    async function carregar() {
      setErro(false);
      let arrayBuffer = null;
      const storagePath = documento.path || documento.storagePathAtual;

      if (storagePath) {
        const blob = await getBlob(ref(storage, storagePath));
        arrayBuffer = await blob.arrayBuffer();
      } else if (documento.url) {
        const resposta = await fetch(documento.url);

        if (!resposta.ok) {
          throw new Error(`Falha ao carregar documento: ${resposta.status}`);
        }

        arrayBuffer = await resposta.arrayBuffer();
      }

      if (!arrayBuffer) {
        throw new Error("Documento sem arquivo para carregar.");
      }

      const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
      const page = await pdf.getPage(1);
      const viewport = page.getViewport({ scale: 2 });
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      canvas.width = viewport.width;
      canvas.height = viewport.height;

      await page.render({ canvasContext: context, viewport }).promise;

      if (ativo) {
        setImagemPdf(canvas.toDataURL("image/png"));
      }
    }

    carregar().catch((err) => {
      console.error("Erro ao carregar PDF:", err);
      if (ativo) setErro(true);
    });

    return () => {
      ativo = false;
    };
  }, [documento.path, documento.storagePathAtual, documento.url]);

  if (erro) {
    return <div className="laudo-carregando">Não foi possível carregar o documento.</div>;
  }

  if (!imagemPdf) {
    return <div className="laudo-carregando">Carregando documento...</div>;
  }

  return <img src={imagemPdf} alt={alt} />;
}

function PaginaImagemLaudo({ modulo, dataRelatorio, imagem, index }) {
  const ehPdf =
    String(imagem.tipo || "").includes("pdf") ||
    /\.pdf($|\?)/i.test(String(imagem.nome || imagem.url || ""));

  return (
    <div className="pagina pagina-laudo-software">
      <Cabecalho modulo={modulo} dataRelatorio={dataRelatorio} codigoCompacto />
      <div className="imagem-laudo-wrapper">
        {ehPdf ? (
          <PdfDocumentoImagem documento={imagem} alt={imagem.nome || `Laudo do ensaio ${index + 1}`} />
        ) : (
          <img src={imagem.url} alt={imagem.nome || `Laudo do ensaio ${index + 1}`} />
        )}
      </div>
      <RodapeRestrito />
    </div>
  );
}

function PaginaCapaCertificado({ modulo, dataRelatorio }) {
  return (
    <div className="pagina pagina-capa-certificado-modulo">
      <Cabecalho modulo={modulo} dataRelatorio={dataRelatorio} codigoCompacto />
      <BlocoEmpresa modulo={modulo} ensaio={false} />

      <div className="titulo-certificado-modulo">
        ANEXO - Certificado de calibração - Aparelho de Módulo Elasticidade.
      </div>

      <Assinatura modulo={modulo} />
      <RodapeRestrito />
    </div>
  );
}

function PaginaCertificado({ certificado }) {
  const ehPdf =
    String(certificado.tipo || "").includes("pdf") ||
    /\.pdf($|\?)/i.test(String(certificado.nomeArquivoOriginal || certificado.url || ""));

  return (
    <div className="pagina pagina-laudo-software">
      <div className="imagem-laudo-wrapper">
        {ehPdf ? (
          <PdfDocumentoImagem
            documento={certificado}
            alt={certificado.nomeArquivoOriginal || "Certificado de calibração"}
          />
        ) : (
          <img src={certificado.url} alt={certificado.nomeArquivoOriginal || "Certificado de calibração"} />
        )}
      </div>
      <RodapeRestrito />
    </div>
  );
}

export default function RelatorioModuloElasticidadePrint({
  modulo,
  onVoltar,
  autoPrint = false,
  mostrarCertificado = true,
}) {
  const jaImprimiuRef = useRef(false);
  useNomeArquivoPdf(modulo?.codigo);
  const dataRelatorio = modulo?.dataRelatorio || modulo?.dataEnsaio || new Date().toISOString().split("T")[0];
  const mediaDinamica = media([modulo?.moduloDinamicoCp1, modulo?.moduloDinamicoCp2], 1);
  const mediaEstatica = media([modulo?.moduloEciCp1, modulo?.moduloEciCp2], 1);
  const idade = modulo?.idadeCp || diferencaDias(modulo?.dataMoldagem, modulo?.dataEnsaio) || "28 dias";
  const idadeValor = numeroIdade(idade);
  const imagensLaudo = Array.isArray(modulo?.laudosEnsaio) ? modulo.laudosEnsaio.filter((img) => img?.url) : [];
  const certificadoAparelho =
    modulo?.certificadoAparelho?.url || modulo?.certificadoAparelho?.storagePathAtual
      ? modulo.certificadoAparelho
      : null;

  useEffect(() => {
    if (!autoPrint || jaImprimiuRef.current) return;

    const timer = window.setTimeout(() => {
      if (jaImprimiuRef.current) return;
      jaImprimiuRef.current = true;
      imprimirEmRetrato();
    }, 500);

    return () => window.clearTimeout(timer);
  }, [autoPrint]);

  if (!modulo) return null;

  return (
    <div className="relatorio-modulo-elasticidade-print">
      {onVoltar && (
        <div className="acoes-print">
          <button className="btn-voltar" onClick={onVoltar}>Voltar</button>
          <button className="btn-imprimir" onClick={imprimirEmRetrato}>Imprimir</button>
        </div>
      )}

      <div className="pagina">
        <Cabecalho modulo={modulo} dataRelatorio={dataRelatorio} />
        <BlocoEmpresa modulo={modulo} />

        <Secao numero="1" titulo="ENSAIO REALIZADO.">
          Determinação dos módulos de elasticidade e de deformação - Método das frequências naturais de vibração - Dinâmico.
        </Secao>

        <Secao numero="2" titulo="OBJETIVO.">
          Este relatório tem por finalidade apresentar os resultados dos ensaios de Módulo de elasticidade realizados em corpos de prova de concreto referentes à obra citada acima.
        </Secao>

        <Secao numero="3" titulo="METODOLOGIA.">
          NBR 8522/2 - Concreto endurecido - Determinação dos módulos de elasticidade e de deformação Parte 2: Módulo de elasticidade dinâmico pelo método das frequências naturais de vibração.
        </Secao>

        <div className="secao">4. AMOSTRA.</div>
        <table className="tabela-amostra">
          <tbody>
            <tr>
              <th>Concreteira:</th>
              <td>{valor(modulo.concreteira)}</td>
              <th>Fck (MPa):</th>
              <td colSpan="2">{fckComUnidade(modulo.fckProjeto)}</td>
            </tr>
            <tr>
              <th>Local de Aplicação:</th>
              <td>{valor(modulo.localAplicacao)}</td>
              <th>Tipo de cura:</th>
              <td colSpan="2">{valor(modulo.tipoCura || "Água")}</td>
            </tr>
            <tr>
              <th>Data da Moldagem:</th>
              <td>{formatarDataBR(modulo.dataMoldagem)}</td>
              <th>Abatimento (mm):</th>
              <td colSpan="2">{valor(modulo.abatimento)}</td>
            </tr>
            <tr>
              <th>Data do Ensaio:</th>
              <td>{formatarDataBR(modulo.dataEnsaio)}</td>
              <th>Nota fiscal/romaneio:</th>
              <td colSpan="2">{valor(modulo.notaFiscalRomaneio)}</td>
            </tr>
            <tr>
              <th>Idade do CP:</th>
              <td>{valor(idade)}</td>
              <th>Número do CP:</th>
              <td>CP1</td>
              <td>CP2</td>
            </tr>
            <tr>
              <th>Tipo de Concreto:</th>
              <td>{valor(modulo.tipoConcreto)}</td>
              <th>Dimensões dos CP's (mm):</th>
              <td>{valor(modulo.alturaCp1)} x {valor(modulo.diametroCp1)}</td>
              <td>{valor(modulo.alturaCp2)} x {valor(modulo.diametroCp2)}</td>
            </tr>
            <tr>
              <th>Preparação dos topos:</th>
              <td>Retificado</td>
              <th>Módulo Elasticidade Eci (GPa):</th>
              <td className="resultado-destaque">{numeroBR(modulo.moduloEciCp1, 2)}</td>
              <td className="resultado-destaque">{numeroBR(modulo.moduloEciCp2, 2)}</td>
            </tr>
          </tbody>
        </table>

        <Secao numero="5" titulo="ANEXO.">
          Anexo 1 - Laudo do ensaio.
        </Secao>

        <div className="secao">6. RESULTADOS OBTIDOS.</div>
        <div className="resultado-texto">
          <p>Valores de Módulo de Elasticidade Dinâmico médio a Compressão obtido: {idadeValor} DIAS: <strong>{mediaDinamica} GPa</strong></p>
          <p>Valores de Módulo de Elasticidade Estático médio a Compressão obtido: {idadeValor} DIAS: <strong>{mediaEstatica} GPa.</strong></p>
          <p>O Módulo de elasticidade estático é aquele considerado no Cálculo estrutural de projeto = <span>{mediaEstatica} GPa.</span></p>
        </div>

        <Secao numero="7" titulo="OBSERVAÇÕES.">
          Os resultados de ensaio(s) e as considerações feitas neste relatório têm significado restrito às amostras analisadas e às condições em que os ensaios foram executados.
        </Secao>

        <Assinatura modulo={modulo} />
        <RodapeRestrito />
      </div>

      <PaginaAnexoCapa modulo={modulo} dataRelatorio={dataRelatorio} />
      {imagensLaudo.slice(0, 2).map((imagem, index) => (
        <PaginaImagemLaudo
          key={imagem.path || imagem.url || index}
          modulo={modulo}
          dataRelatorio={dataRelatorio}
          imagem={imagem}
          index={index}
        />
      ))}
      {mostrarCertificado && certificadoAparelho && (
        <>
          <PaginaCapaCertificado modulo={modulo} dataRelatorio={dataRelatorio} />
          <PaginaCertificado certificado={certificadoAparelho} />
        </>
      )}
    </div>
  );
}


